import { render, staticRenderFns } from "./DiseaseInsights.vue?vue&type=template&id=1a4c2b35&scoped=true&"
import script from "./DiseaseInsights.vue?vue&type=script&lang=js&"
export * from "./DiseaseInsights.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseInsights.vue?vue&type=style&index=0&id=1a4c2b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c2b35",
  null
  
)

export default component.exports